import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postAcceptInvitation } from '../../../api';
import { setJWTToken } from '@sonar-software/sonar-ts-lib';

export const securityInvitationsAcceptPostSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successDataHandlers: [
			(data) => {
				if (data.token) {
					setJWTToken(data.token);
				}
			}
		]
	},
	name: 'SecurityInvitationsAccept',
	receive: true,
	request: true,
	requestHandler: postAcceptInvitation
});
